
// A special Reducer to handle the post/patch/delete errors that are not associated to any another reducer

import {
    FLAG_QUESTION,
    FLAG_QUESTION_ERROR,
    FLAG_QUESTION_LOADING,
    ADD_QUESTION_TO_PLAYLISTS_ERROR,
    ADD_QUESTION_TO_PLAYLISTS_LOADING,
    ADD_COMMENT,
    ADD_COMMENT_LOADING,
    ADD_COMMENT_ERROR
} from "../../actions/actionTypes";

const initialState = {
    flagQuestion : {
        loading : false ,
        error : null
    },
    buildQuiz : {
        loading : false ,
        error : null
    },
    addQuestionToPlaylist: {
        loading : false ,
        error : null
    },
    addComment : {
        loading : false ,
        error : null
    }
}

export default function reqErrorsReducer (state = initialState, action) {
    switch(action.type){
        case ADD_QUESTION_TO_PLAYLISTS_ERROR:
            return {
                ...state ,
                addQuestionToPlaylist: {
                    error : action.payload ,
                    loading : false
                }
            }
        case ADD_QUESTION_TO_PLAYLISTS_LOADING:
            return {
                ...state ,
               addQuestionToPlaylist: {
                    error : null,
                   loading : true
               }
            }
        // case POST_ADD_QUESTION_TO_PLAYLIST:
        //     return {
        //         ...state,
        //         addQuestionToPlaylist: {
        //             error: null ,
        //             loading : false
        //         }
        //     }
        case FLAG_QUESTION:
            return {
                ...state ,
                flagQuestion: {
                    ...state.flagQuestion,
                    loading : false,
                    error : null
                }
            }
        case FLAG_QUESTION_LOADING:
            return {
                ...state,
                flagQuestion: {
                    ...state.flagQuestion,
                    loading : true ,
                    error : null
                }
            }
        case FLAG_QUESTION_ERROR:
            return {
                ...state,
                flagQuestion: {
                    ...state.flagQuestion,
                    loading : false,
                    error : action.payload
                }
            }
        case ADD_COMMENT:
            return {
                ...state ,
                addComment: {
                    ...state.addComment,
                    loading : null ,
                    error : false
                }
            }
        case ADD_COMMENT_LOADING:
            return {
                ...state ,
                addComment: {
                    loading : true,
                    error : null
                }
            }
        case ADD_COMMENT_ERROR:
            return {
                ...state,
                addComment: {
                    loading: null,
                    error : action.payload
                }
            }
        default: return state
    }
}

